<!--
 * @FilePath: /netHallOfficialAccounts/src/views/Bind/selectBindAccount.vue
-->
<template>
  <div class="selectBindAccount-page">
    <div class="acount-title">
      <p>选择绑定用水账户</p>
      <!-- <span v-if="code === '0004' || code === '0005' || code === '0006'">
        客户"{{ userName }}"有{{ num }}个用水状态正常的账户,请选择要绑定的账户
      </span>
      <span v-else-if="code === '0007'">
        客户"{{ userName }}"有{{ num }}个已报停的用水账户,请选择要绑定的账户
      </span> -->
      <span> 有{{ num }}个用水账户 , 请绑定账户 </span>
    </div>
    <div class="account-content" v-if="dataInfoFlag">
      <ul v-if="isMultiple">
        <li v-for="(item, index) in unBindData" :key="index">
          <van-cell-group>
            <van-field label="户号" v-model="item.clientCode" readonly label-width="50px">
              <!-- <template #button>
                <van-checkbox v-model="item.isChoose" :disabled="item.isDisabled" />
              </template> -->
            </van-field>

            <van-field label="地址" v-model="item.clientAddress" readonly label-width="50px" />
            <!-- 标签 -->
            <van-cell>
              <label-tag
                :value="item.signName"
                :currentIndex="index"
                @getTagValue="getInputValueInfo"
              />
            </van-cell>
          </van-cell-group>
        </li>
      </ul>
      <!-- 单选 -->
      <ul v-else>
        <li v-for="(item, index) in unBindData" :key="index">
          <van-cell-group>
            <van-field label="户号" v-model="item.clientCode" readonly label-width="50px">
            </van-field>

            <van-field label="地址" v-model="item.clientAddress" readonly label-width="50px" />
            <!-- 标签 -->
            <van-cell>
              <label-tag
                :value="item.signName"
                :currentIndex="index"
                @getTagValue="getInputValueInfo"
              />
            </van-cell>
          </van-cell-group>
        </li>
      </ul>
      <div class="account-submit">
        <van-button type="info" :loading="bindloading" block @click="submitContent">立即绑定</van-button>
      </div>
    </div>
    <no-data v-else />
  </div>
</template>

<script>
import { bindClient, selectWaterUserDetails, selectWaterUserParams, getBindList } from '../../api/user';
import LabelTag from '@/components/labelTag';
import { Dialog, Toast } from 'vant';
import store from '@/store';
import { mapState } from 'vuex';
import {debounce} from "lodash-es";

export default {
  name: 'selectBindAccount',
  components: {
    LabelTag
  },
  computed: {
    ...mapState('user', {
      homeInfo: (state) => state.homeInfo,
      pathUrl: (state) => state.pathUrl
    })
  },
  data() {
    return {
      dataInfo: [],
      userName: '',
      num: '',
      isMultiple: true, // 默认多选
      result: '',
      code: '',
      dataInfoFlag: true,
      unBindData: [],
      signName: '',
      bindloading: false
    };
  },
  mounted() {
    this.bindUserByIdNum();
    // 用户绑定的页面进来时 多选 如果时业务办理 进来时 单选
    if (this.pathUrl && this.pathUrl.url && this.pathUrl.url.length > 0) {
      this.code = this.pathUrl.code;
      this.isMultiple = false;
    } else {
      this.isMultiple = true;
    }
  },
  methods: {
    async bindUserByIdNum() {
      // const homeInfo = await getBindList(store.getters.userInfo.userId);
      // const { status, resultData, errorMessage } = await selectWaterUserDetails(this.$route.query.clientCode);
      console.log(this.$route.query)

      let param = {
        clientCode: this.$route.query.clientCode,
        clientPhone: this.$route.query.phone || '',
        clientIdNum: this.$route.query.clientIdNumber || ''
      }
      const { status, resultData, errorMessage } = await selectWaterUserParams(param);
      //过滤没有绑定的数据
      //   resultData.map((item) => {
      //     let bindInfo = homeInfo.resultData.find((item1) => item1.clientCode === item.clientCode);
      //     console.log(bindInfo)
      //     if (!bindInfo) {
      //       unBindData.push(item);
      //     }
      // });
      this.num = resultData.length || 0;
      this.unBindData = resultData;
    },
    // 标签
    getInputValueInfo(msg, index) {
      this.unBindData[index].signName = msg;
    },
    submitContent:debounce(async function() {
      console.log(this.unBindData[0])
      if (!this.unBindData[0].signName) {
        return Toast('请选择标签');
      }
      this.bindloading = true;
      let params = {
          userId: store.getters.userInfo.userId,
          clientCode: this.unBindData[0].clientCode,
          customerNo: this.unBindData[0].clientName,
          bindGroup: this.unBindData[0].signName,
          accountType: 'wx'
      };
        console.log(params)
        const { status, resultData } = await bindClient(params);
        if (status === 'complete') {
          // 更新是否绑定状态
          if (
              this.pathUrl &&
              this.pathUrl.url &&
              this.pathUrl.url.length > 0 &&
              this.pathUrl.url !== '/Bind'
            ) {
              this.$router.push({ path: this.pathUrl.url });
            } else {
              this.$router.push({ name: 'Home', path: '/' });
            }
        }
        this.bindloading = false;
    }, 1000)
  }
};
</script>

<style lang="less" scoped>
.selectBindAccount-page {
  width: 100%;
  height: 100%;
  .acount-title {
    padding: 20px 16px;
    background-color: #ffffff;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #1c2734;
      line-height: 26px;
      font-weight: 700;
      margin: 0px;
    }
    span {
      display: block;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #999999;
      line-height: 26px;
    }
  }
  .account-content {
    ul {
      margin-bottom: 80px;
      li {
        background-color: #ffffff;
        margin: 16px;
        border-radius: 8px;
      }
    }
    .van-cell-group {
      margin: 2px;
    }
    .account-submit {
      width: 90%;
      position: fixed;
      bottom: 0px;
      padding: 16px;
      background: #ffffff;
      .van-button {
        border-radius: 8px;
      }
    }
  }
}
</style>
